import { Box, Card as MuiCard, CardContent as MuiCardContent, makeStyles, Typography, CardActions, } from "@material-ui/core"
import { spacing } from "@material-ui/system";
import { NavLink } from "react-router-dom";
import styled from "styled-components/macro";
import { getURL, urls } from "../routes";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)(spacing);
const CardContent = styled(MuiCardContent)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-bottom:0px;
`
const DayWrapper = styled.div`
    box-shadow: 0px 0px 16.9299px rgba(53, 64, 82, 0.05);
    border-radius: 4.83711px;
`;
const DayText = styled.div`
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const useStyles = makeStyles((theme) => ({
    noUnitsWrapper: {
        height: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
    },
    noUnitsCard: {
        padding: "40px",
        cursor: 'auto',
    },
    alignCenter: {
        display: "flex",
        justifyContent: "center"
    },
    navLink: {
        textDecoration: "none"
    }
}))

export const NoUnitsCard = (p: {
    id: string
}) => {
    const { id } = p;
    const classes = useStyles();
    const { t } = useTranslation();
    return <Box className={classes.noUnitsWrapper}>
        <Card className={classes.noUnitsCard}>
            <CardContent style={{ cursor: 'auto' }}>
                <Typography gutterBottom >
                    {t("questionUnits_beforeClassification")}
                </Typography>
            </CardContent>
            <CardActions className={classes.alignCenter} >
                <NavLink to={getURL(urls.selectFacilities, { id })} className={classes.navLink}>
                    <DayWrapper>
                        <DayText>
                            {t("questionUnits_editFacilities")}
                        </DayText>
                    </DayWrapper>
                </NavLink>
            </CardActions>
        </Card>
    </Box>
}